import React from "react";
import '../styles.css';

const NameCell = (cellData) => {
  return (
    cellData.key.deleted
    ? <div style={{'text-decoration': 'line-through', color: '#596E79'}}>{cellData.text}</div>
    : <div>{cellData.text}</div>
)
};

export default NameCell;
